import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, ROUTE_PATHS } from '@constants';
import { CONTENT_TYPE } from '@enums';
import { useStore } from '@hooks';
import { Icon } from '@ui';
import { observer } from 'mobx-react';
import {
    AddCampaignButton,
    ButtonsContainer,
    CloseButton,
    ContentContainer,
    DescriptionText,
    Divider,
    HeaderContainer,
    HeaderRow,
    IconContainer,
    ModalContent,
    ModalTitle,
    StyledModal,
    TextContainer
} from './styled';

export const CreateCampaignModal = observer(({ setIsModalOpen, isModalOpen }) => {
    const navigate = useNavigate();
    const store = useStore();
    const { updateAccount, isManualWithSyncInProgressOrFailed } = store.accountsStore;
    const { hasPreLaunchedCampaign } = store.campaignsStore;

    const handleClose = async () => {
        setIsModalOpen(false);
        await updateAccount(
            {
                showModal: {
                    createCampaign: false
                }
            },
            CONTENT_TYPE.JSON
        );
    };

    const handleAddCampaign = async () => {
        try {
            await handleClose();
        } finally {
            setIsModalOpen(false);
            navigate(ROUTE_PATHS.CAMPAIGNS_PRE_WIZARD);
        }
    };

    return (
        <StyledModal
            width={630}
            open={isModalOpen}
            onCancel={handleClose}
            footer={null}
            maskClosable={false}
            closable={false}
            destroyOnClose
        >
            <ModalContent>
                <HeaderContainer>
                    <HeaderRow>
                        <ModalTitle level={2}>Create your first campaign</ModalTitle>
                        <CloseButton type='noStyle' onClick={handleClose}>
                            <Icon size='24px' color={COLORS.$gray60Black} component={() => <Icon.CloseIcon />} />
                        </CloseButton>
                    </HeaderRow>
                    <Divider />
                </HeaderContainer>

                <ContentContainer>
                    <IconContainer>
                        <Icon size='80px' color={COLORS.$gray40Black} component={() => <Icon.CampaignIcon />} />
                    </IconContainer>
                    <TextContainer>
                        <DescriptionText type='descriptor1'>
                            The more campaigns you have, the greater the chance your products will be shown to
                            consumers!
                        </DescriptionText>
                    </TextContainer>
                </ContentContainer>

                <ButtonsContainer>
                    <AddCampaignButton
                        onClick={handleAddCampaign}
                        type='primary'
                        disabled={hasPreLaunchedCampaign || isManualWithSyncInProgressOrFailed}
                        iconRight={<Icon size='24px' color={COLORS.$white} component={() => <Icon.PlusIcon />} />}
                    >
                        Add New Campaign
                    </AddCampaignButton>
                </ButtonsContainer>
            </ModalContent>
        </StyledModal>
    );
});

export default CreateCampaignModal;
